import { axiosInstanceV2 } from "./AxiosInstance"

const API_URL = "/apps"

export const getApps = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let queryParams = `?limit=${limit}&page=${page}`
    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`
    }
    if (searchField) {
      queryParams += `&searchField=${searchField}`
    }
    const response = await axiosInstanceV2.get(`${API_URL}${queryParams}`)
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching apps", error)
    throw error
  }
}

export const createApps = async (appData) => {
  try {
    const response = await axiosInstanceV2.post(API_URL, appData)
    return response.data
  } catch (error) {
    console.error("Error creating app", {
      error: error.response?.data,
      requestData: appData,
    })
    throw error
  }
}

export const updateApps = async (appId, appData) => {
  try {
    const response = await axiosInstanceV2.put(`${API_URL}/${appId}`, appData)
    return response.data
  } catch (error) {
    console.error("Error updating app", error)
    throw error
  }
}

export const deleteApps = async (appId) => {
  try {
    const response = await axiosInstanceV2.delete(`${API_URL}/${appId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting app", error)
    throw error
  }
}

export const getAppsById = async (appId) => {
  try {
    const response = await axiosInstanceV2.get(`${API_URL}/${appId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching app details", error)
    throw error
  }
}
